export var VERTICAL_CLICK_OPTIONS = {
  behavior: 'smooth',
  inline: 'nearest',
  block: 'center'
};
export var HORIZONTAL_CLICK_OPTIONS = {
  behavior: 'smooth',
  inline: 'center',
  block: 'nearest'
};
export var VERTICAL_START_OPTIONS = {
  inline: 'nearest',
  block: 'center'
};
export var HORIZONTAL_START_OPTIONS = {
  inline: 'center',
  block: 'nearest'
};